/*
 * LBAG custom - libelles des cartes Searchanise sur les pages de collection.
 *
 * Reprend le patron qui existait dans le theme Providence (2021) et qui a ete
 * perdu lors du passage a LBAG 6.5.x en 2023 : on ecoute Searchanise et on
 * reetiquette le bouton de la carte selon les tags du produit.
 *
 * La grille de collection est rendue par Searchanise, PAS par le theme, donc
 * snippets/add-to-cart-form*.liquid n'a aucun effet ici.
 *
 * Etats geres :
 *   tag "Disponible Bientot"              -> "Bientot disponible" / "Coming Soon"
 *   tag "Disponible en magasin seulement" -> "En magasin" / "In store only"
 * Tout le reste est laisse tel quel (Searchanise gere deja la rupture de stock).
 *
 * NOTE : ce fichier est charge en `defer`, donc Searchanise a deja peint la
 * grille quand on s'abonne. S'abonner ne suffit pas : on rate le premier
 * "ResultsUpdated". D'ou la passe de rattrapage + l'observateur ci-dessous.
 */
(function () {
  'use strict';

  var LABELS = {
    fr: { soon: 'Bientôt disponible', store: 'En magasin' },
    en: { soon: 'Coming Soon', store: 'In store only' }
  };

  function labels() {
    var loc = (window.Shopify && window.Shopify.locale) ||
              document.documentElement.lang || 'fr';
    return LABELS[String(loc).slice(0, 2).toLowerCase()] || LABELS.en;
  }

  // Searchanise slugifie les tags en SUPPRIMANT les accents (il ne les replie pas) :
  //   "Disponible Bientot" -> snize-product-tag-disponible-bientt
  //   "Bio & sans allergenes" -> snize-product-tag-bio--sans-allergnes
  var CLASS_SOON  = 'snize-product-tag-disponible-bientt';
  var CLASS_STORE = 'snize-product-tag-disponible-en-magasin-seulement';
  var TAG_SOON    = 'disponible bient';
  var TAG_STORE   = 'disponible en magasin seulement';

  var items = [];

  function hasTag(product, needle) {
    var tags = (product && product.tags) || [];
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase().indexOf(needle) === 0) return true;
    }
    return false;
  }

  function relabel(card, text) {
    var btn = card.querySelector('.snize-view-product-button');
    if (!btn || btn.getAttribute('data-lbag-labelled') === text) return;
    btn.textContent = text;
    btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('data-lbag-labelled', text);
  }

  function apply() {
    var cards = document.querySelectorAll('.snize-product');
    if (!cards.length) return;
    var L = labels();
    var byId = {};
    items.forEach(function (p) { if (p && p.product_id) byId[p.product_id] = p; });

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var product = byId[(card.id || '').replace('snize-product-', '')];

      if (card.classList.contains(CLASS_SOON) || hasTag(product, TAG_SOON)) {
        relabel(card, L.soon);
      } else if (card.classList.contains(CLASS_STORE) || hasTag(product, TAG_STORE)) {
        relabel(card, L.store);
      }
    }
  }

  // Re-applique en cas de re-rendu (filtres, tri, pagination) meme si on rate
  // l'evenement : Searchanise remplace le contenu de son conteneur.
  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = setTimeout(function () { scheduled = null; apply(); }, 60);
  }

  function observe() {
    var root = document.getElementById('snize_results') || document.body;
    try {
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    } catch (e) { /* pas d'observateur : les evenements suffisent */ }
  }

  var bound = false;
  function bind() {
    if (bound) return true;
    var $ = window.Searchanise && window.Searchanise.$;
    if (!$) return false;
    bound = true;
    $(document).on('Searchanise.DataRequestEnd', function (e, type, params, resp) {
      items = (resp && resp.items) || [];
    });
    $(document).on('Searchanise.ResultsUpdated', schedule);
    return true;
  }

  function start() {
    bind();
    if (start.done) { apply(); return; }
    start.done = true;
    observe();
    apply();                      // rattrapage : la grille est deja peinte
    setTimeout(apply, 500);       // filet si elle ne l'est pas encore
    setTimeout(apply, 2000);
  }

  if (!bind()) {
    document.addEventListener('Searchanise.Loaded', start);
    setTimeout(start, 1500);      // filet si "Loaded" a deja ete emis
  } else {
    start();
  }
})();
